import Modifier from "../Modifier";

class LimitDataModifier extends Modifier {

    constructor(parameters) {
        super(parameters);
        this.name = 'limit';
        this.min = parameters.min;
        this.max = parameters.max;
    }

    compute(data) {
        let that = this;
        return data.filter(function (point) {
            return point.time >= that.min && point.time <= that.max;
        })
    }

}

export default LimitDataModifier;
